module.exports = __webpack_public_path__ + "b8fbd6397edd19fa86b08805fefb19e7.pdf";